import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Input,
  Space,
  Typography,
  InputNumber,
  Modal,
  Form,
  message,
  Select,
  Divider,
  Checkbox,
  Tabs

} from "antd";
import { PlusOutlined, MinusOutlined, DeleteOutlined } from "@ant-design/icons";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import API from "../../api";
import "../SalePos/customStyles.css";


const { Meta } = Card;
const { Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

export default function SalePos() {
  const [form] = Form.useForm();
  const [customerForm] = Form.useForm();

  const [products, setProducts] = useState([]);
  // const [filteredProducts, setFilteredProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [cart, setCart] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [scannerVisible, setScannerVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productQuantity, setProductQuantity] = useState(1);
  const [productDiscount, setProductDiscount] = useState(0);
  const [scannedData, setScannedData] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [showCustomerModel, setShowCustomerModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [stock, setStock] = useState(null);
  const [customerId, setCustomerId] = useState();
  const [user, setUser] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [salePayload, setSalePayload] = useState([]);
  const [iscountsList, setDiscountsList] = useState([]);
  const [payable, setPayable] = useState(0); // Payable amount
  const [discountType, setDiscountType] = useState(null);
  const [discountValue, setDiscountValue] = useState(0);
  const [saleDiscount, setSaleDiscount] = useState({ value: 0, type: "percentage" });
  const [taxes, setTaxes] = useState([]);


  const fetchProducts = async () => {
    try {
      const response = await API.get("/products");
      const discountsResponse = await API.get("/discounts");
      const productsWithBarcode = response.data.map((product) => ({
        ...product,
        barcode: product.barcode || "", // Ensure barcode field exists
      }));
      setDiscountsList(discountsResponse)
      setProducts(productsWithBarcode || []);
      setFilteredProducts(productsWithBarcode || []);
    } catch (error) {
      console.error("Error fetching products:", error.message);
      message.error("Failed to fetch products. Please try again.");
    }
  };

  const fetchTax = async () => {
    try {
      const taxResponse = await API.get("/taxes")
      setTaxes(taxResponse?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Failed to fetch data.");
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handlePaymentSubmit = () => {
    // Handle form submission logic
    handlePayment();
    setIsModalOpen(false);
  };


  // const getStores = async() => {
  //   try {
  //     const responseStore = await API.get(`/stores/${user.storeId}`);
  //     console.log(responseStore)
  //   } catch (error) {

  //   }
  // }

  useEffect(() => {
    fetchProducts();
    getCustomers();
    fetchTax();
    getUser();
    
  }, []);


  const filterProductsByQuery = () => {
    if (!searchQuery) {
      setFilteredProducts(products);
      return;
    }
    const query = searchQuery.toLowerCase();

    // Filter products by name, barcode, or combined "name (code)" format
    const filtered = products.filter((product) => {
      const name = product?.specifications?.name?.toLowerCase() || "";
      const barcode = product?.barcode?.code?.toLowerCase() || "";
      const combined = `${name} (${barcode})`; // Combine name and barcode in "name (code)" format

      return (
        name.includes(query) || // Match name
        barcode.includes(query) || // Match barcode
        combined.includes(query) // Match combined format
      );
    });

    setFilteredProducts(filtered);
  };

  useEffect(() => {
    filterProductsByQuery();
  }, [searchQuery, products]);

  useEffect(() => {
    if (selectedProduct?.storeDetails?.availability) {
      const prod = selectedProduct.storeDetails.availability.find(
        (product) => {
          const sto = product.products.productList.find((item) => item?.product === selectedProduct?._id)
          setStock(sto?.quantity);
          //console.log(sto.quantity);
        }
      );
      // Uncomment the following line to update the stock state if needed
      // setStock(prod?.stock || 0); // Safely set stock to 0 if prod or prod.stock is undefined
    }
  }, [selectedProduct]);

  const getCustomers = async () => {
    try {
      const response = await API.get("/customers");
      setCustomers(response.data);
    } catch (err) {
      console.error("Error fetching customers:", err);
      message.error("Failed to load customers.");
    }
  };


  const openModal = (product) => {
    setSelectedProduct(product);
    setProductQuantity(1);
    setProductDiscount(0);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedProduct(null);


  };

  const handleAddToCart = () => {
    if (!selectedProduct) return;

    setCart((prev) => {
      const existingItem = prev.find((item) => item.productId === selectedProduct._id);
      const productPurchasePrice = selectedProduct?.pricing?.purchasePrice || 0;

      if (existingItem) {
        // Update existing item
        if (existingItem.stock < existingItem.quantity + productQuantity) {
          message.error("Insufficient stock.");
          return prev; // Return previous state unchanged
        }

        // Calculate the total price using the correct price (purchase or sale)
        const priceToUse = existingItem.purchasePrice > 0 ? existingItem.purchasePrice : selectedProduct.pricing.salePrice;
        return prev.map((item) =>
          item.productId === selectedProduct._id
            ? {
              ...item,
              quantity: item.quantity + productQuantity,
              discount: item.discount + productDiscount,
              totalPrice:
                (item.quantity + productQuantity) * priceToUse -
                (item.discount + productDiscount),
              purchasePrice: productPurchasePrice,  // Update purchase price
            }
            : item
        );
      } else {
        // Add new item
        if (stock < productQuantity) {
          message.error("Insufficient stock.");
          return prev;
        }

        const priceToUse = productPurchasePrice > 0 ? productPurchasePrice : selectedProduct.pricing.salePrice;
        return [
          ...prev,
          {
            stock,
            productId: selectedProduct._id,
            name: selectedProduct.specifications.name,
            quantity: productQuantity,
            totalPrice:
              productQuantity * priceToUse - (productDiscount || 0), // Use the selected price
            discount: productDiscount,
            barcode: selectedProduct.barcode.code,
            hsn_sac: selectedProduct.hsn_sac || "",
            mrpPrice: selectedProduct.pricing.mrpPrice || 0,
            salePrice: selectedProduct.pricing.salePrice || 0,
            purchasePrice: selectedProduct.pricing.salePrice, // Add purchase price
            taxes: selectedProduct?.taxes || null,
            productDiscount: {
              value: 0,
              type: "percentage",
            },
          },
        ];
      }
    });

    closeModal();
  };

  const handleQuantityChange = (productId, quantity) => {
    if (quantity < 1) {
      message.error("Quantity must be at least 1.");
      return;
    }

    setCart((prev) =>
      prev.map((item) => {
        if (item.productId === productId) {
          if (item.stock < quantity) {
            message.error("Insufficient stock.");
            return item; // Return unchanged item
          }

          // Use the purchase price if available
          const priceToUse = item.purchasePrice > 0 ? item.purchasePrice : item.salePrice;
          let totalPrice = priceToUse * quantity;

          // Apply product-level discount
          totalPrice = applyProductDiscount(item, totalPrice);

          totalPrice = Math.max(totalPrice, 0); // Ensure total price is not negative

          return {
            ...item,
            quantity,
            totalPrice: parseFloat(totalPrice.toFixed(2)),
            purchasePrice: item.purchasePrice,  // Maintain the purchase price
          };
        }
        return item;
      })
    );
  };

  const handleBarcodeScan = (err, result) => {
    if (result) {
      const scannedBarcode = result.text;
      setScannedData(scannedBarcode);

      const matchingProduct = products.find(
        (product) => product?.barcode?.code === scannedBarcode
      );

      if (matchingProduct) {
        const productInCart = cart.find((item) => item.barcode === scannedBarcode);

        if (productInCart) {
          if (productInCart.stock < productInCart.quantity + 1) {
            message.error("Insufficient stock.");
            setScannerVisible(false);
            return;
          }

          setCart(
            cart.map((item) =>
              item.barcode === scannedBarcode
                ? {
                  ...item,
                  quantity: item.quantity + 1,
                  totalPrice: applyProductDiscount(
                    item,
                    item.purchasePrice * (item.quantity + 1) // Use purchasePrice for calculation
                  ),
                  purchasePrice: matchingProduct?.pricing?.purchasePrice || item.purchasePrice, // Update purchase price
                }
                : item
            )
          );
          setScannerVisible(false);
          setSelectedProduct(matchingProduct);
          setProductQuantity(1);
          setProductDiscount(0);
          setScannedData(null);

          message.success(`Product "${matchingProduct.specifications.name}" updated in cart.`);
        } else {
          setSelectedProduct(matchingProduct);
          setProductQuantity(1);
          setProductDiscount(0);
          setModalVisible(true);
          setScannerVisible(false);

          message.success(`Product "${matchingProduct.specifications.name}" added to cart.`);
        }
      } else {
        setScannerVisible(false);
        message.error("No matching product found for the scanned barcode.");
      }
    } else if (err) {
      console.error("Barcode scanning error:", err);
      setScannedData(null);
    }
  };



  const applyProductDiscount = (
    item,
    totalPrice,
    discountType = item.productDiscount?.type,
    discountValue = item.productDiscount?.value,
  ) => {
    // Apply discount (percentage or flat)
    if (discountType === "percentage" && discountValue) {
      totalPrice -= (discountValue / 100) * totalPrice;
    } else if (discountType === "flat" && discountValue) {
      totalPrice -= discountValue * item.quantity;
    }

    // Round the total price to two decimal places
    return parseFloat(totalPrice.toFixed(2));
  };

  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((item) => item.productId !== id));
  };
  const updateDiscount = (productId, discountType, discountValue) => {
    setCart((prev) =>
      prev.map((item) => {
        if (item.productId === productId) {
          const basePrice = item.purchasePrice || item.salePrice;
          const totalBasePrice = basePrice * item.quantity;

          // Validate discount inputs
          if (discountType === "percentage" && discountValue > 100) {
            message.error("Percentage discount cannot exceed 100%.");
            return item;
          }

          if (discountType === "flat" && discountValue > totalBasePrice) {
            message.error("Flat discount cannot exceed the total price.");
            return item;
          }

          // Apply the discount and calculate the total price per product
          let totalPrice = totalBasePrice;
          totalPrice = applyProductDiscount(item, totalPrice, discountType, discountValue);

          totalPrice = Math.max(totalPrice, 0); // Ensure total price is not negative

          return {
            ...item,
            totalPrice,
            productDiscount: {
              type: discountType,
              value: discountValue,
            },
          };
        }
        return item;
      })
    );
  };


  const formatNumber = (number) => {
    return `₹${new Intl.NumberFormat().format(number)}`;
  };

  const columns = [
    {
      title: "Product ID",
      dataIndex: "productId",
      key: "productId",
      render: (productId) => {
        const product = products.find((prod) => prod._id === productId);
        return product ? product?.specifications?.name : "Unknown";
      },
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (_, record) => (
        <Input
          type="number"
          value={record.quantity}
          min={1}
          onChange={(e) =>
            handleQuantityChange(record.productId, Number(e.target.value))
          }
        />
      ),
    },
    {
      title: "Discount",
      key: "discount",
      render: (_, record) => (
        <Space>
          <Input
            addonAfter={
              <Select
                value={record.productDiscount?.type || "percentage"}
                onChange={(value) =>
                  updateDiscount(
                    record.productId,
                    value,
                    record.productDiscount?.value || 0
                  )
                }
              >
                <Option value="percentage">%</Option>
                <Option value="flat">Flat</Option>
              </Select>
            }
            type="number"
            placeholder="Discount"
            value={record.productDiscount?.value || ""}
            onChange={(e) => {
              const value = Number(e.target.value);
              if (value < 0) {
                message.error("Negative values are not allowed.");
                return;
              }
              updateDiscount(
                record.productId,
                record.productDiscount?.type || "percentage",
                value
              );
            }}
          />
        </Space>
      ),
    },

    {
      title: "Purchase Price",
      dataIndex: "purchasePrice",
      key: "purchasePrice",
      render: (_, record) => (
        <Input
          type="number"
          value={record.purchasePrice}
          min={1}
          onChange={(e) => {
            const newValue = Number(e.target.value);

            // Validate that purchase price does not exceed MRP
            if (newValue > record.mrpPrice) {
              message.error("Purchase Price cannot be greater than MRP.");
              return;
            }

            handlePurchasePriceChange(record.productId, newValue);
          }}
        />
      ),
    },

    {
      title: "MRP",
      dataIndex: "mrpPrice",
      key: "mrpPrice",
      render: (value) => formatNumber(value),
    },
    {
      title: "Sale Price",
      dataIndex: "salePrice",
      key: "salePrice",
      render: (value) => formatNumber(value),
    },
    {
      title: "Tax",
      key: "taxes",
      render: (_, record) => (
        <Select
          style={{ minWidth: 100 }}
          placeholder="Select Tax"
          value={record.taxes?._id || null}
          dropdownStyle={{ fontSize: 6 }} 
          onChange={(value) => {
            const selectedTax = taxes.find((tax) => tax._id === value);
            setCart((prev) =>
              prev.map((item) =>
                item.productId === record.productId
                  ? {
                    ...item,
                    taxes: selectedTax,
                  }
                  : item
              )
            );
          }}
        >
          {taxes.length === 0 ? (
            <Option disabled>No Tax available</Option>
          ) : (
            taxes.map((tax) => (
              <Option key={tax._id} value={tax._id}  style={{ fontSize: 11 }}>
                <text style={{fontSize:11}}>
                {`${tax.taxName} (${tax.percentage}%)`}
                </text>
              </Option>
            ))
          )}
        </Select>
      ),
    },
    {
      title: "Total Price",
      dataIndex: "totalPrice",
      key: "totalPrice",
      render: (value) => formatNumber(value),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button danger onClick={() => removeFromCart(record.productId)}>
          Remove
        </Button>
      ),
    },
  ];
  const handlePurchasePriceChange = (productId, newPurchasePrice) => {
    setCart((prev) =>
      prev.map((item) => {
        if (item.productId === productId) {
          // Validate that purchase price does not exceed MRP
          if (newPurchasePrice > item.mrpPrice) {
            message.error("Purchase Price cannot be greater than MRP.");
            return item; // Return unchanged item if validation fails
          }

          // Calculate the new total price after purchase price change
          let updatedTotalPrice = newPurchasePrice * item.quantity;

          // Apply product-level discount
          updatedTotalPrice = applyProductDiscount(item, updatedTotalPrice);

          updatedTotalPrice = Math.max(updatedTotalPrice, 0); // Ensure total price is not negative

          return {
            ...item,
            purchasePrice: newPurchasePrice, // Update purchase price
            totalPrice: updatedTotalPrice,   // Update total price based on the new purchase price
          };
        }
        return item;
      })
    );
  };



  const total = cart?.reduce(
    (sum, item) => sum + (item?.unitPrice - (item?.discount || 0)) * item?.quantity,
    0
  );





  const handleSubmit = async (values) => {
    setIsLoading(true);

    try {
      const { taxableAmount, netTotal, totalDiscount, totalAmount, totalAmountWithoutTax } = calculateSummary();
      const salePayloadData = {
        ...values,
        storeId: user.storeId ? user.storeId : null,
        products: cart.map((item) => ({
          productId: item.productId,
          hsn_sac: item.hsn_sac,
          mrpPrice: item.mrpPrice,
          quantity: item.quantity,
          productDiscount: item.productDiscount,
          salePrice: item.salePrice,
          totalPrice: item.totalPrice,
          purchasePrice: item.purchasePrice, // Add purchasePrice to payload
          taxes: item.taxes
            ? [
              {
                taxId: item.taxes._id,
                taxName: item.taxes.taxName,
                percentage: item.taxes.percentage,
              },
            ]
            : [],
        })),
        status:"completed",
        discount: saleDiscount,
        totalDiscount: totalDiscount,
        totalAmountWithoutTax: totalAmountWithoutTax,
        totalAmount: totalAmount
      };
      setSalePayload(salePayloadData);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Sale submission error:", error);
      message.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };


  const handlePayment = async () => {
    try {
      await API.post("/sales", salePayload);
      message.success("Sale completed successfully!");
      setCart([]);
      fetchProducts();
    } catch (error) {
      console.error("Sale submission error:", error);
      message.error(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    const customerName = customers.find(
      (product) => product?._id == salePayload.customerId
    );
    setCustomerId(customerName?.name ? customerName?.name : null);

  }, [salePayload])

  const handleSearch = (value) => {
    // Optional: Perform any custom filtering logic here if needed
    console.log('Searching for: ', value);
  };


  const calculatePayable = () => {
    let updatedPayable = total;

    if (discountType === "percentage") {
      updatedPayable = total - (total * discountValue) / 100;
    } else if (discountType === "flat") {
      updatedPayable = total - discountValue;
    }

    setPayable(Math.max(updatedPayable, 0));
  };

  const handleTypeChange = (value) => {
    setDiscountType(value);
  };

  const handleValueChange = (value) => {
    setDiscountValue(value);
  };

  const handleAddCustomer = async (values) => {
    setIsLoading(true);
    try {
      const { address, ...rest } = values;
      const payload = {
        ...rest,
        address: {
          street: address?.street,
          city: address?.city,
          state: address?.state,
          pincode: address?.pincode,
        },
      };
      const res = await API.post("/customers", payload);
      if (res?.status == 200) { message.success("Customer added successfully!"); }

      form.resetFields();
      setShowCustomerModel(false);
      getCustomers();
    } catch (error) {
      console.error("Submit failed:", error);
      message.error(error.response?.data?.message || "Submit failed.");
    } finally {
      setIsLoading(false);
    }
  };

  const getUser = () => {
    try {
      const userType = JSON.parse(localStorage.getItem('userData'));
      setUser(userType)
    } catch (err) {
      message.error("Failed to fetch branches. Please try again.");
    }
  };


  // Trigger calculation on state change
  useEffect(() => {
    calculatePayable();
  }, [discountType, discountValue, total]);



  const calculateSummary = () => {
    let netTotal = 0;
    let totalDiscount = 0;
    let taxableAmount = 0;

    cart.forEach((item) => {
      const basePrice = item.purchasePrice || item.salePrice;
      const total = basePrice * item.quantity;

      // Calculate discount
      const discount =
        item.productDiscount?.type === "percentage"
          ? (item.productDiscount.value / 100) * total
          : item.productDiscount?.value * item.quantity || 0;

      // Calculate taxable amount based on taxes
      const tax = item.taxes?.percentage
        ?  (total - ((total) / (1+((item.taxes.percentage) / 100))))
        : 0;

      taxableAmount += tax;
      netTotal += total;
      totalDiscount += discount;
    });

    // Apply purchase-level discount
    const purchaseLevelDiscount =
      saleDiscount.type === "percentage"
        ? (saleDiscount.value / 100) * (netTotal - totalDiscount)
        : saleDiscount.value || 0;

    const totalAmount = netTotal - totalDiscount - purchaseLevelDiscount;
    const totalAmountWithoutTax = netTotal - totalDiscount - purchaseLevelDiscount - taxableAmount;

    return {
      netTotal: netTotal.toFixed(2), // Ensure 2 decimal places
      totalDiscount: (totalDiscount + purchaseLevelDiscount).toFixed(2), // Ensure 2 decimal places
      taxableAmount: taxableAmount.toFixed(2), // Ensure 2 decimal places
      totalAmount: Math.max(totalAmount, 0).toFixed(2), // Ensure total amount is not negative and rounded
      totalAmountWithoutTax: Math.max(totalAmountWithoutTax, 0).toFixed(2), // Ensure total amount is not negative and rounded
    };
  };


  return (
    <div

      style={{
        height: "10vh",
        width: '95vw',
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f9f9f9",
      }}
    >
      <div
      // style={{
      //   margin: "20px",
      //   height: "10vh",
      //   width: "95vw",
      //   display: "flex",
      //   flexDirection: "column",
      //   backgroundColor: "#f9f9f9",
      //   borderRadius: "8px",
      //   boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      // }}
      >
        <Row gutter={16} style={{ height: "100%" }}>
          {/* Right Column: Cart and Customer Selection */}
          <Col
            xs={24}
            lg={14}
            style={{
              padding: "24px",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              marginBottom: "24px",
            }}
          >
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              <Row gutter={16} style={{ alignItems: "center" }}>
                <Col>
                  <Form.Item
                    name="customerId"
                    rules={[{ required: true, message: "Please select a customer." }]}
                    style={{ width: '100%', minWidth: 250, marginBottom: 0 }}
                  >
                    <Select
                      placeholder="Select Customer"
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                      onSearch={handleSearch}
                    >
                      {customers.map((customer) => (
                        <Option key={customer?._id} value={customer?._id}>
                          {customer?.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setShowCustomerModel(true)}
                    style={{
                      borderRadius: "8px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                </Col>
              </Row>

              <Space direction="vertical" style={{ width: "100%" }}>

                <Table
                  columns={columns}
                  dataSource={cart}
                  rowKey="productId"
                  pagination={false}
                  className="small-font-table" // Add a custom class for styling
                  footer={() => {
                    // Calculate the summary values
                    const { taxableAmount, netTotal, totalDiscount, totalAmount, totalAmountWithoutTax } = calculateSummary();

                    const netTotalNum = Number(netTotal) || 0;

                    return (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          marginTop: "16px",
                          borderTop: "1px solid #e8e8e8",
                          paddingTop: "16px",
                        }}
                      >
                        {/* Discount Section */}
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <Input
                            addonAfter={
                              <Select
                                value={saleDiscount.type}
                                onChange={(value) =>
                                  setSaleDiscount((prev) => ({
                                    ...prev,
                                    type: value,
                                  }))
                                }
                              >
                                <Option value="percentage">%</Option>
                                <Option value="flat">Flat</Option>
                              </Select>
                            }
                            type="number"
                            placeholder="Sale Discount"
                            value={saleDiscount.value || ""}
                            onChange={(e) => {
                              const value = Number(e.target.value);
                              if (value < 0) {
                                message.error("Negative values are not allowed.");
                                return;
                              }
                              const { type } = saleDiscount;

                              // Validation logic
                              if (type === "percentage" && value > 100) {
                                message.error("Percentage discount cannot exceed 100%.");
                                return;
                              }
                              if (type === "flat" && value > netTotalNum) {
                                message.error("Flat discount cannot exceed the total amount.");
                                return;
                              }

                              setSaleDiscount((prev) => ({
                                ...prev,
                                value,
                              }));
                            }}
                            style={{ width: 200 }}
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-end", // Align all elements to the right side
                            justifyContent: "center",
                          }}
                        >
                          {/* Tax Details */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-end",
                            }}
                          >
                            <div>
                              <strong>Net Total:</strong>{" "}
                              <span style={{ color: "#ff0000" }}>{formatNumber(netTotal)}</span>
                            </div>
                            <div>
                              <strong>Discount:</strong>{" "}
                              <span style={{ color: "#000" }}>{formatNumber(totalDiscount)}</span>
                            </div>
                            <div>
                              <strong>Tax:</strong>{" "}
                              <span style={{ color: "#000" }}>{formatNumber(taxableAmount)}</span>
                            </div>
                            <div>
                              <strong>Payable (Before Tax):</strong>{" "}
                              <span style={{ color: "#008000", fontWeight: "bold" }}>
                                {formatNumber(totalAmountWithoutTax)}
                              </span>
                            </div>
                            <div>
                              <strong>Total Payable (After Discount and Tax):</strong>{" "}
                              <span style={{ color: "#0000ff", fontWeight: "bold" }}>
                                {formatNumber(totalAmount)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "16px",
                    alignItems: "center",
                  }}
                >

                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    danger
                    style={{
                      marginRight: "8px",
                      borderRadius: "8px",
                      padding: "8px 20px", // Adjusted padding for better proportions
                      fontWeight: "bold",
                    }}
                    onClick={() => setCart([])}
                  >
                    Empty Cart
                  </Button>
                  <Button
                    type="primary"
                    style={{ borderRadius: "8px", padding: "0 16px" }}
                    htmlType="submit"
                    disabled={!cart.length}
                  >
                    Payment
                  </Button>
                </div>
              </Space>
            </Form>
          </Col>
          {/* Left Column: Product Search and Display */}
          <Col xs={24} lg={10} style={{ padding: 0, overflowY: "auto", height: "100vh" }}>
            <Space direction="vertical" style={{ width: "100%", padding: "16px", height: "100%", overflowY: "auto" }}>
              <Input.Search
                placeholder="Search by name or barcode"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  marginBottom: "16px",
                  borderRadius: "8px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                }}
                allowClear
              />


              <Button
                type="primary"
                onClick={() => setScannerVisible(true)}
                style={{
                  marginBottom: "16px",
                  borderRadius: "8px",
                }}
              >
                Open Barcode Scanner
              </Button>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                  gap: "16px",
                  padding: "16px",
                  height: "calc(100vh - 160px)", // Adjust height to allow for the search bar and button
                  overflow: "auto",
                }}
              >
                {filteredProducts.map((product) => (
                  <Card
                    key={product?._id}
                    hoverable
                    cover={
                      <img
                        alt={product?.specifications?.name}
                        src={`http://localhost:5001/${product.image}`}
                        style={{
                          height: "150px",
                          objectFit: "contain",
                          borderRadius: "8px 8px 0 0",
                        }}
                      />
                    }
                    onClick={() => openModal(product)}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "250px",
                      border: "1px solid #e8e8e8",
                      borderRadius: "8px",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease", // Add transition for hover effect
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)"; // Scale the card on hover
                      e.currentTarget.style.boxShadow = "0px 6px 12px rgba(0, 0, 0, 0.2)"; // Increase the shadow on hover
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)"; // Reset scale when mouse leaves
                      e.currentTarget.style.boxShadow = "0px 4px 8px rgba(0, 0, 0, 0.1)"; // Reset shadow when mouse leaves
                    }}
                  >
                    <Meta
                      title={product?.specifications?.name}
                      description={
                        <Text style={{ color: "#52c41a", fontWeight: "bold" }}>
                          Price: {product?.pricing?.salePrice}
                        </Text>
                      }
                    />
                    <div style={{ textAlign: "right" }}>
                      <Text style={{ color: "#595959" }}>
                        Code: {product?.barcode?.code}
                      </Text>
                    </div>
                  </Card>
                ))}

              </div>
            </Space>
          </Col>



        </Row>
      </div>


      <Modal
        title={
          <div
            style={{
              textAlign: "center",
              fontSize: "24px",
              fontWeight: "bold",
              color: "#4a90e2",
              letterSpacing: "1px",
            }}
          >
            🛍️ Product Details
          </div>
        }
        open={modalVisible}
        onCancel={closeModal}
        onOk={stock ? handleAddToCart : null}
        okText="Add to Cart"
        cancelText="Cancel"
        centered
        okButtonProps={{ disabled: !stock }}
        style={{
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
          overflow: "hidden",
        }}
        width={600}
      >
        {selectedProduct && (
          <Form
            layout="vertical"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Form.Item>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Text strong style={{ fontSize: "18px", color: "#555" }}>Product Name:</Text>
                <Text style={{ fontSize: "16px", textAlign: "right" }}>
                  {selectedProduct?.specifications?.name}
                </Text>
              </div>
            </Form.Item>
            <Form.Item>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Text strong style={{ fontSize: "18px", color: "#555" }}>Available Stock:</Text>
                <Text style={{ color: stock ? "#4a90e2" : "red", fontSize: "16px", fontWeight: "bold", textAlign: "right" }}>
                  {stock ? stock : "Not Available Right Now"}
                </Text>
              </div>
            </Form.Item>
            <Form.Item>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Text strong style={{ fontSize: "18px", color: "#555" }}>Price:</Text>
                <Text style={{ color: "#52c41a", fontSize: "16px", fontWeight: "bold", textAlign: "right" }}>
                  ₹ {selectedProduct?.pricing?.salePrice}
                </Text>
              </div>
            </Form.Item>
            <Form.Item label={<Text strong style={{ fontSize: "18px", color: "#555" }}>Quantity</Text>}>
              <InputNumber
                min={1}



                max={stock || 1000}
                value={productQuantity}
                onChange={(value) => setProductQuantity(value)}
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  border: "1px solid #d9d9d9",
                  padding: "4px 12px",
                }}
                placeholder="Enter quantity"
              />
            </Form.Item>
            <Form.Item label={<Text strong style={{ fontSize: "18px", color: "#555" }}>Discount</Text>}>
              <InputNumber
                min={0}
                value={productDiscount}
                onChange={(value) => setProductDiscount(value)}
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  border: "1px solid #d9d9d9",
                  padding: "4px 12px",
                }}
                placeholder="Enter discount"
              />
            </Form.Item>
          </Form>
        )}
      </Modal>



      {showCustomerModel && <Modal
        title={
          <div
            style={{
              textAlign: "center",
              fontSize: "24px",
              fontWeight: "bold",
              color: "#4a90e2", // Blue color for title
              letterSpacing: "1px",
              justifyContent: "center", // Center horizontally
              gap: "10px", // Space between emoji and text
            }}
          >
            <span style={{ fontSize: "30px" }}>👥</span> Customer Details
          </div>
        }
        open={showCustomerModel}
        footer={null}
        onCancel={() => setShowCustomerModel(false)}
        style={{
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
          overflow: "hidden",
        }}

        width={600}
      >
        <Form
          form={customerForm}
          layout="vertical"
          onFinish={handleAddCustomer}
          style={{
            backgroundColor: "#f9f9f9", // Light background for form
            padding: "24px",
            borderRadius: "12px",
          }}
        >
          <Form.Item
            label={<Text strong style={{ fontSize: "18px", color: "#555" }}>Customer Name</Text>}
            name="name"
            rules={[{ required: true, message: "Please enter the customer name!" }]}
          >
            <Input
              placeholder="Customer Name"
              style={{
                borderRadius: "8px", // Rounded corners
                borderColor: "#d9d9d9", // Light border color
              }}
            />
          </Form.Item>

          <Form.Item
            label={<Text strong style={{ fontSize: "18px", color: "#555" }}>Email</Text>}
            name="email"
            rules={[ { type: "email", message: "Please enter a valid email!" }]}
          >
            <Input
              placeholder="Please enter the email"
              style={{
                borderRadius: "8px",
                borderColor: "#d9d9d9",
              }}
            />
          </Form.Item>

          <Form.Item
            label={<Text strong style={{ fontSize: "18px", color: "#555" }}>Phone</Text>}
            name="phone"
            rules={[{ required: true, message: "Please enter the phone number!" }]}
          >
            <Input
              placeholder="Please enter the phone number"
              style={{
                borderRadius: "8px",
                borderColor: "#d9d9d9",
              }}
            />
          </Form.Item>

          <Form.Item label={<Text strong style={{ fontSize: "18px", color: "#555" }}>Address</Text>}>
            <Form.Item
              label={<Text strong style={{ fontSize: "16px", color: "#555" }}>Street</Text>}
              name={["address", "street"]}

            >
              <Input
                placeholder="Please enter the street"
                style={{
                  borderRadius: "8px",
                  borderColor: "#d9d9d9",
                }}
              />
            </Form.Item>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label={<Text strong style={{ fontSize: "16px", color: "#555" }}>City</Text>}
                  name={["address", "city"]}
                >
                  <Input
                    placeholder="Please enter the city"
                    style={{
                      borderRadius: "8px",
                      borderColor: "#d9d9d9",
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={<Text strong style={{ fontSize: "16px", color: "#555" }}>State</Text>}
                  name={["address", "state"]}
                >
                  <Input
                    placeholder="Please enter the state"
                    style={{
                      borderRadius: "8px",
                      borderColor: "#d9d9d9",
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label={<Text strong style={{ fontSize: "16px", color: "#555" }}>Pincode</Text>}
              name={["address", "pincode"]}
              rules={[ { pattern: /^[0-9]+$/, message: "Pincode must be numeric!" }]}
            >
              <Input
                placeholder="Enter pincode"
                type="text"
                style={{
                  borderRadius: "8px",
                  borderColor: "#d9d9d9",
                }}
              />
            </Form.Item>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              block
              style={{
                borderRadius: "8px", // Rounded button
              }}
            >
              Save
            </Button>
          </Form.Item>
        </Form>
      </Modal>


      }
      {scannerVisible && <Modal
        title="Scan Barcode"
        open={scannerVisible}
        footer={null}
        onCancel={() => setScannerVisible(false)}
        centered
      >
        <BarcodeScannerComponent
          width={475}
          height={500}
          onUpdate={handleBarcodeScan}
        />
        <p>Scanned Data: {scannedData || "No barcode scanned yet"}</p>
      </Modal>}


      <Modal
        title="Finalize Sale"
        visible={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={900}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form layout="vertical">
              {/* Row 1: Customer Info and Total Payable */}
              <Row justify="end" align="middle">
                <Col>
                  <span>
                    <strong>Customer:</strong> {customerId}
                  </span>
                </Col>
              </Row>

              {/* Row 2: Discount Section */}
              <Row justify="space-between" align="middle" style={{ marginTop: 20 }}>
                <Col span={8}>
                  <div>
                    <strong>Net Total Without Tax:</strong>
                    <h3 style={{ color: "purple" }}>₹ {new Intl.NumberFormat("en-IN").format(salePayload?.totalAmountWithoutTax)}</h3>
                  </div>
                </Col>
                <Col span={8}>
                  <div>
                    <strong>Discount :</strong>
                    <h3 style={{ color: "red" }}>₹{new Intl.NumberFormat("en-IN").format((salePayload?.totalDiscount ? salePayload?.totalDiscount : 0))}</h3>
                  </div>
                </Col>
                <Col span={8}>
                  <div>
                    <strong>Payable:</strong>
                    <h3 style={{ color: "green" }}>₹{new Intl.NumberFormat("en-IN").format(salePayload?.totalAmount)}</h3>
                  </div>
                </Col>
              </Row>



              {/* Row 6: Checkboxes */}
              <Row style={{ marginTop: 16 }}>
                <Col>
                  <Checkbox>Send Invoice Via SMS</Checkbox>
                </Col>
                <Col style={{ marginLeft: 16 }}>
                  <Checkbox>Send Invoice Via Email</Checkbox>
                </Col>
              </Row>

              {/* Divider */}
              <Divider />

              {/* Row 5: Action Buttons */}
              <Row justify="space-between">
                <Col>
                  <Button danger onClick={handleCancel}>
                    Cancel
                  </Button>
                </Col>
                <Col>
                  <Button type="primary" onClick={handlePaymentSubmit}>
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Modal>


    </div>
  );
}
